// extracted by mini-css-extract-plugin
export default {"section":"section---yAWvu","warnMessage":"warnMessage---R4iqc","warnIcon":"warnIcon---V4Xes"};